import { useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { api, errorMessage } from "@/lib/adminApi";
import { FIELD } from "@/components/admin/AdminLogin";

const SAMPLE = 'author,rating,text,date\nJane D.,5,"Paid on time every week.",2026-06-01';

export default function ImportCsv({ onImported }) {
    const [csv, setCsv] = useState("");
    const [busy, setBusy] = useState(false);
    const [result, setResult] = useState(null);

    const onFile = (e) => {
        const f = e.target.files?.[0];
        if (!f) return;
        f.text().then(setCsv);
    };

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const { data } = await api.post("/admin/testimonials/import", { csv });
            setResult(data);
            toast.success(`${data.imported} imported, ${data.duplicates} duplicates skipped`);
            setCsv("");
            if (data.imported > 0) onImported();
        } catch (err) {
            toast.error(errorMessage(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <form onSubmit={submit} className="rounded-2xl border border-border bg-surface p-6" data-testid="import-csv-form">
            <h2 className="font-display text-lg font-bold">Bulk import (CSV)</h2>
            <p className="mt-1 text-xs text-muted-foreground">
                Columns: <code className="font-mono">author, rating, text, date</code>. Duplicates are skipped automatically, so re-importing the same export twice a week is safe.
            </p>
            <label className="mt-5 flex cursor-pointer items-center gap-2 rounded-xl border border-dashed border-border px-4 py-3 text-sm text-muted-foreground transition-colors hover:border-primary hover:text-primary">
                <Upload size={15} /> Choose a .csv file
                <input type="file" accept=".csv,text/csv" onChange={onFile} className="hidden" data-testid="import-csv-file" />
            </label>
            <textarea
                rows={7}
                required
                placeholder={SAMPLE}
                value={csv}
                onChange={(e) => setCsv(e.target.value)}
                className={`${FIELD} mt-3 resize-y font-mono text-xs`}
                data-testid="import-csv-text"
            />
            {result && (
                <p className="mt-3 font-mono text-xs text-muted-foreground" data-testid="import-csv-result">
                    Imported {result.imported} · duplicates {result.duplicates} · skipped {result.skipped}
                </p>
            )}
            <button type="submit" disabled={busy || !csv.trim()} data-testid="import-csv-submit" className="mt-5 rounded-full bg-primary px-6 py-2.5 text-sm font-bold text-primary-foreground transition-transform duration-200 hover:scale-[1.03] active:scale-95 disabled:opacity-50">
                {busy ? "Importing…" : "Import to pending"}
            </button>
        </form>
    );
}
